/**
 * Created by Jew on 9/5/2017.
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { IdexService } from 'app/idex.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

declare let $: any;
declare let moment: any;
declare let numeral: any;

@Component({
   selector: 'app-tax-report',
   templateUrl: './tax-report.component.html',
   styleUrls: ['./tax-report.component.css']
})
export class TaxReportComponent implements OnInit {
   @ViewChild('paginator', { static: true }) paginator: MatPaginator;
   tin: string;
   size = 50;
   user: any;
   errorMessage: string;
   doc: any;
   user_role: any;
   user_name: any;
   data: any;
   len: any;
   title: any;
   month_title: any;
   hasMore: boolean;
   type: any;
   year: number;
   month: any;
   month_list = [
      {value: '01', viewValue: 'มกราคม'},
      {value: '02', viewValue: 'กุมภาพันธ์'},
      {value: '03', viewValue: 'มีนาคม'},
      {value: '04', viewValue: 'เมษายน'},
      {value: '05', viewValue: 'พฤษภาคม'},
      {value: '06', viewValue: 'มิถุนายน'},
      {value: '07', viewValue: 'กรกฎาคม'},
      {value: '08', viewValue: 'สิงหาคม'},
      {value: '09', viewValue: 'กันยายน'},
      {value: '10', viewValue: 'ตุลาคม'},
      {value: '11', viewValue: 'พฤศจิกายน'},
      {value: '12', viewValue: 'ธันวาคม'}
   ];
   dataprint: any;
   load = true;
   displayedColumns = ['no', 'doc_date', 'doc_no', 'doc_type', 'name', 'taxId', 'amount', 'vat', 'total'];
   dataSource: MatTableDataSource<any>;

   constructor(private service: IdexService,
               private router: Router,
               private route: ActivatedRoute,
               public dialog: MatDialog) {
      this.user = this.service.user;
   }

   ngOnInit() {
      this.route.params.subscribe((params: Params) => {
         this.tin = params.tin;
         this.type = params.type;
         this.year = parseInt(params.year, 10);
         this.month = params.month;
         for (let i = 0; i < this.user.business.length; i++) {
            if (this.user.business[i].tin === this.tin) {
               this.user_role = this.user.business[i].role;
               this.user_name = this.user.business[i].name;
            }
         }
         this.month_title = this.month_list.filter(
            x => x.value === this.month
         );
         this.month_title = this.month_title[0].viewValue;
         this.getAllReport();
         if (this.type === 'buy') {
            this.title = 'รายงานภาษีซื้อ';
         } else if (this.type === 'sell') {
            this.title = 'รายงานภาษีขาย';
         }
         $('#print-zone').hide();
      });
   }

   // getReport() {
   //    this.service.get('/work/' + this.tin + '/report/' + this.type + '/' + this.year + '/' + this.month
   //       + '?index=' + this.index + '&size=' + this.size)
   //       .subscribe(
   //          data => {
   //             this.data = data.items;
   //             this.hasMore = data.hasMore;
   //             this.line = this.index;
   //
   //             this.load = false;
   //          });
   //
   // }
   getAllReport() {
      this.service.get('/work/' + this.tin + '/report/' + this.type + '/' + this.year + '/' + this.month)
         .subscribe(
            data => {
               this.dataprint = data.items;
               this.len = data.total;
               this.load = false;
               this.dataSource = new MatTableDataSource(this.dataprint);
               setTimeout(() =>
                  this.dataSource.paginator = this.paginator
               );
            });
   }

   viewfile(item: any) {
      const url = '/content?id=' + item.id + '&token=' + this.user.token;
      if (item.mimeType === 'application/pdf' || item.mimeType.indexOf('image/') === 0) {
         window.open(this.service.url + url);
      } else {
         this.service.get(url)
            .subscribe((data: any) => {
               const attach_url = this.service.url + '/attachment?id='
                  + item.id + '&aid=' + data.attachments[0].id + '&token=' + this.user.token;
               window.open(attach_url);
            }, error => {
               this.errorMessage = error;
            });
      }
   }

   print() {
      let printContents, popupWin;
      printContents = document.getElementById('print-zone').innerHTML;
      popupWin = window.open('', '_blank');
      popupWin.document.open();
      popupWin.document.write(`
      <html>
        <head>
          <title>zDOX</title>
          <style>
          .header_report {
             width: 90%;
             border: 1px solid white;
             background-color: white;
             padding: 20px;
             margin: 0 auto;
           }
           table {
             font-family: arial, sans-serif;
             border-collapse: collapse;
             width: 100%;
             font-size: 12px;
             /*page-break-inside:auto*/
           }

            td, th {
                border: 1px solid #dddddd;
                text-align: left;
                padding: 8px;
               word-wrap: break-word;
               max-width: 200px;
            }

            tr:nth-child(1) {
                background-color: #4b5049;
                color: white;
            }
            th {
                text-align: center;
            }
            td:nth-child(5) {
                text-align: left;
            }
            td:nth-child(0), td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4), td:nth-child(6) {
                text-align: center;
            }
            td:nth-child(7), td:nth-child(8), td:nth-child(9) {
                text-align: right;
            }
            .size {
                min-height: 250px;
                align-items: start;
            }
            h3,h2 {
                text-align: center;
                margin: 30px;
                font-weight: normal;
            }
            td a {
                cursor: pointer;
            }
            tr {
               page-break-inside: avoid;
               page-break-after: auto;
            }
          </style>
        </head>
      <body onload="window.print();window.close()">${printContents}</body>
      </html>`
      );
      popupWin.document.close();
   }

   formatNumber(value: any) {
      return numeral(value).format('0,0.00');
   }

   formatDate(date: any) {
      const d = moment(date);
      return d.format('DD/MM/') + (parseInt(d.format('YYYY'), 10) + 543);
   }
}

